var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcXWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88659 5.32367C6.45502 4.89211 5.75532 4.89211 5.32376 5.32367C4.89219 5.75524 4.89219 6.45494 5.32375 6.88651L14.4372 16L5.32367 25.1135C4.89211 25.5451 4.89211 26.2448 5.32367 26.6763C5.75524 27.1079 6.45494 27.1079 6.88651 26.6763L16 17.5628L25.1135 26.6763C25.5451 27.1079 26.2448 27.1079 26.6763 26.6763C27.1079 26.2447 27.1079 25.545 26.6763 25.1135L17.5629 16L26.6762 6.88655C27.1078 6.45498 27.1078 5.75528 26.6762 5.32371C26.2447 4.89214 25.545 4.89214 25.1134 5.32371L16 14.4371L6.88659 5.32367Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXWhite);
export default __webpack_public_path__ + "static/media/ic_x_white.028c0d0e46c69f045a908698f836023f.svg";
export { ForwardRef as ReactComponent };